import React from 'react';

type Props = any;

const BookmarkAppExtensionContent = (props: Props) => {
  return <div>BookmarkAppExtensionContent</div>;
};

export default BookmarkAppExtensionContent;
